import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SponsoredTrainingBannerDialogComponent } from '@cpd-app/core-module/components/sponsored-training-banner-dialog/sponsored-training-banner-dialog.component';
import { SponsorshipCompany } from '@cpd-app/generated';
import { Observable } from 'rxjs';

@Injectable()
export class SponsorTrainingBannerService {
  public constructor(private dialog: MatDialog) {}

  public openDisplaySponsoredBanner(
    pathwayId: string,
    sponsor: SponsorshipCompany
  ): Observable<boolean> {
    return this.dialog
      .open(SponsoredTrainingBannerDialogComponent, {
        width: '732px',
        maxHeight: '750px',
        data: { sponsor, pathwayId },
        position: {
          right: '0'
        },
        panelClass: 'right-slide-dialog'
      })
      .afterClosed();
  }
}
